import {isApiTrue} from "../is-api-true";

export const getSampleMailingCardError = (address) => {
    if (isAddressEmpty(address)) {
        return "No Sample Card Address on file. Please add an address to continue.";
    }

    if (
        !address.name && !address.name2 ||
        !address.address ||
        !address.city ||
        !address.state ||
        !address.zip
    ) {
        return "This address is missing information. Please edit and update the address to continue.";
    }

    if (address.countryCode?.length !== 2) {
        return "There was an error importing your mailing address. Please edit and update the address to continue.";
    }

    if (isApiTrue(address.failed)) {
        return "This address has failed CASS check";
    }
};

const addressAttrs = [
    "name",
    "name2",
    "address",
    "city",
    "state",
    "zip",
];
export const isAddressEmpty = (address) => {
    return !address || !addressAttrs.some((attr) => address[attr]);
};

